export default __webpack_public_path__ + "assets/bannersplash-5b8df40a6a9ccb14afc84c0a789149f2.png";